
export enum BusinessModuleType {
    Legacy = 'legacy',
    Calendar = 'calendar',
    Ticket = 'ticket',
    Pool = 'pool',
    PointOfInterest = 'poi',
    Gym = 'gym',
    TicketBooking = 'ticket-booking',
}
